import {GridColDef, GridColumnHeaderParams} from '@mui/x-data-grid';
import React from 'react';
import {
  IBackgroundTask,
  IBackgroundTaskType,
} from '../../api/types/backgroundTask.type';
import DownloadFileButton from './download-file-button/DownloadFileButton';
import {getReportDownload} from '../../api/endpoints/backgroundTasksAPI';
import {NotificationResponse} from '../../api/types/notifications.type';
import {getPrintReport} from '../../api/endpoints/projectApi';
import {getProductionBatesRangeReport} from '../../api/endpoints/productionApi';
import DocumentNameCell from './DocumentNameCell/DocumentNameCell';
import {getDomainDashboardReport} from '../../api/endpoints/dashboardApi';
import {Box} from '@mui/material';
import {getAIInvestigateTranscriptReport} from '../../api/endpoints/aiInvestigateApi';

export enum NotificationTypes {
  INGESTIONSUMMARY = 'INGESTIONSUMMARY',
  EXPORTREPORT = 'EXPORTREPORT',
  PROJECT = 'PROJECT',
  DOMAINDASHBOARDXPORT = 'DOMAINDASHBOARDXPORT',
  DOCUMENTPRINTER = 'DOCUMENTPRINTER',
  CATEGORIZATION = 'CATEGORIZATION',
  PRODUCTIONBATESRANGE = 'PRODUCTIONBATESRANGE',
  CONCEPTCLUSTERSUMMARYREPORT = 'CLUSTERSUMMARYREPORT',
  BATCHREDACTION = 'BATCHREDACTION',
  BATCHPRINT = 'BATCHPRINT',
  UNPUBLISHDOCLIST = 'UNPUBLISHDOCLIST',
  BACKGROUNDREPORT = 'BACKGROUNDREPORT',
  PRODUCTIONCOMMIT = 'PRODUCTION-COMMIT',
  PRODUCTIONUNCOMMIT = 'PRODUCTION-UNCOMMIT',
  PRODUCTIONCANCEL = 'PRODUCTION-CANCEL',
  EXPORTCANCEL = 'EXPORT-CANCEL',
  SAVEDSEARCH = 'SAVEDSEARCH',
  SESSIONSEARCH = 'SESSIONSEARCH',
  BULKACTIONTAG = 'BULKACTION-TAG',
  BULKACTIONUNTAG = 'BULKACTION-UNTAG',
  BULKACTIONFOLDER = 'BULKACTION-FOLDER',
  BULKACTIONUNFOLDER = 'BULKACTION-UNFOLDER',
  BULKACTIONRELEASE = 'BULKACTION-RELEASE',
  BULKACTIONUNRELEASE = 'BULKACTION-UNRELEASE',
  BULKACTIONASSIGN = 'BULKACTION-ASSIGN',
  BULKACTIONUNASSIGN = 'BULKACTION-UNASSIGN',
  QUICKBATCHASSIGN = 'QUICKBATCH-ASSIGN',
  SHAREREPORT = 'SHAREREPORT',
  REPORTSCHEDULE = 'REPORTSCHEDULE',
  AUTOINGESTION = 'AUTOINGESTION',
  SGEMAILINCLUSIVE = 'SGEMAILINCLUSIVE',
  AUTOPUBLISH = 'AUTOPUBLISH',
  TRANSCRIPTREPORT = 'TRANSCRIPTREPORT',
}

export const BackgroundTaskTypes: IBackgroundTaskType[] = [
  {key: 1, value: '', isSelected: false, text: 'Select Task Type'},
  {
    key: 2,
    value: 'BULKACTION-ASSIGN',
    isSelected: false,
    text: 'Assign Documents (Add)',
  },
  {
    key: 3,
    value: 'BULKACTION-UNASSIGN',
    isSelected: false,
    text: 'Assign Documents (Remove)',
  },
  {
    key: 4,
    value: 'BULKACTION-FOLDER',
    isSelected: false,
    text: 'Folder Documents (Add)',
  },
  {
    key: 5,
    value: 'BULKACTION-UNFOLDER',
    isSelected: false,
    text: 'Folder Documents (Remove)',
  },
  {
    key: 6,
    value: 'BULKACTION-RELEASE',
    isSelected: false,
    text: 'Release Documents (Add)',
  },
  {
    key: 7,
    value: 'BULKACTION-UNRELEASE',
    isSelected: false,
    text: 'Release Documents (Remove)',
  },
  {key: 8, value: '6', isSelected: false, text: 'Report'},
  {key: 9, value: 'SEARCH', isSelected: false, text: 'Search'},
  {
    key: 10,
    value: 'BULKACTION-TAG',
    isSelected: false,
    text: 'Tag Documents (Add)',
  },
  {
    key: 11,
    value: 'BULKACTION-UNTAG',
    isSelected: false,
    text: 'Tag Documents (Remove)',
  },
  {key: 12, value: 'BATCHPRINT', isSelected: false, text: 'Batch Print'},
  {
    key: 13,
    value: 'BATCHREDACTION',
    isSelected: false,
    text: 'Batch Redactions',
  },
  {
    key: 14,
    value: 'QUICKBATCH-ASSIGN',
    isSelected: false,
    text: 'Quickbatch Assign',
  },
  {
    key: 15,
    value: 'DOCUMENTPRINTER',
    isSelected: false,
    text: 'Document Print',
  },
  {
    key: 16,
    value: 'DATASETSUMMARYREPORT',
    isSelected: false,
    text: 'Dataset Summary Report',
  },
  {
    key: 17,
    value: 'COLLSUMMARYREPORT',
    isSelected: false,
    text: 'Collection Summary Report',
  },
  {
    key: 18,
    value: 'CLUSTERSUMMARYREPORT',
    isSelected: false,
    text: 'Cluster Summary Report',
  },
  {
    key: 19,
    value: 'DOCVIEW-REDACTION',
    isSelected: false,
    text: 'Docview Redaction/Highlight/Remark',
  },
];

export const createPreciseTimestampedFilename = (baseName: string) => {
  const now = new Date();
  const pad = (number: number, length = 2) => {
    return String(number).padStart(length, '0');
  };

  const year = now.getFullYear();
  const month = pad(now.getMonth() + 1);
  const day = pad(now.getDate());
  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());

  const milliseconds = pad(now.getMilliseconds(), 3);
  const timestampPart = `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;

  const filename = `${baseName}_${timestampPart}`;
  return filename;
};

const isBackgroundTask = (
  notification: NotificationResponse | IBackgroundTask
): notification is IBackgroundTask => {
  return (notification as IBackgroundTask).documentName !== undefined;
};

export const handleDownload = async (
  item: NotificationResponse | IBackgroundTask,
  handleErrorToast: (message: boolean) => void = () => {}
): Promise<void> => {
  let resourceId: string = '';
  let notificationTypeCode: string = '';
  let notificationId: number = 0;
  let filePath: string = '';

  if (isBackgroundTask(item)) {
    resourceId = item.documentName;
    notificationTypeCode = item.notificationTypeCode;
    notificationId = Number(item.documentName);
    filePath = item.message;
  } else {
    resourceId = item.id.toString();
    notificationTypeCode = item.notificationTypeCode;
    notificationId = item.notificationID;
    filePath = item.remarks || '';
  }

  if (!resourceId || !notificationTypeCode) {
    console.error(
      'Download failed: Missing resourceId or notificationTypeCode.'
    );
    return;
  }

  const filename = createPreciseTimestampedFilename(notificationTypeCode);
  switch (notificationTypeCode) {
    case NotificationTypes.CONCEPTCLUSTERSUMMARYREPORT:
    case NotificationTypes.INGESTIONSUMMARY:
    case NotificationTypes.UNPUBLISHDOCLIST: {
      const {isSuccess = false, data: response} = await getReportDownload(
        extractReportId(filePath)
      );
      const baseName = generateBaseName(notificationTypeCode, filePath);
      const filename = createPreciseTimestampedFilename(baseName);
      if (response instanceof Blob && isSuccess) {
        const blob = response;
        downloadBlob(blob, filename);
      } else {
        handleErrorToast(true);
        console.error(
          `Download failed for type ${notificationTypeCode}. Expected Blob response.`
        );
      }
      break;
    }
    case NotificationTypes.EXPORTREPORT: {
      const {
        isSuccess = false,
        data: response,
        headers,
      } = await getReportDownload(extractReportId(filePath));

      const baseName = generateBaseName(notificationTypeCode, filePath);
      const generatedName = createPreciseTimestampedFilename(baseName);

      if (response instanceof Blob && isSuccess) {
        const contentType =
          headers['content-type'] || 'application/octet-stream';
        const contentDisposition = headers['content-disposition'] || '';

        let filenameFromHeader = '';
        const match = contentDisposition.match(
          /filename\*?=(?:UTF-8'')?("?)([^";]+)\1/
        );
        if (match?.[2]) {
          filenameFromHeader = match[2];
        }

        const cleanGenerated = generatedName.replace(/\.[^/.]+$/, '');

        const extensionMap: Record<string, string> = {
          'text/csv': 'csv',
          'text/tab-separated-values': 'tab',
          'application/pdf': 'pdf',
          'application/json': 'json',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            'xlsx',
        };

        const finalFilename =
          filenameFromHeader ||
          `${cleanGenerated}.${extensionMap[contentType] || 'dat'}`;

        const blob = new Blob([response], {type: contentType});
        downloadBlob(blob, finalFilename);
      } else {
        handleErrorToast(true);
        console.error(
          `Download failed for type ${notificationTypeCode}. Expected Blob response.`
        );
      }
      break;
    }
    case NotificationTypes.BATCHREDACTION: {
      const id = extractReportId(filePath);
      const {isSuccess = false, data: response} = await getReportDownload(id);
      const isAnalysisReport = isAnalysis(filePath);
      const filename = createPreciseTimestampedFilename(
        isAnalysisReport ? 'BRPVW' : 'BRRPT'
      );
      if (response instanceof Blob && isSuccess) {
        const blob = response;
        downloadBlob(blob, filename);
      } else {
        handleErrorToast(true);
        console.error(
          `Download failed for type ${notificationTypeCode}. Expected Blob response.`
        );
      }
      break;
    }
    case NotificationTypes.PRODUCTIONBATESRANGE: {
      const response = await getProductionBatesRangeReport(resourceId);

      if (response instanceof Blob) {
        const csvFilename = `${filename}.csv`;
        const csvBlob = new Blob([response], {type: 'text/csv;charset=utf-8;'});
        downloadBlob(csvBlob, csvFilename);
      } else {
        handleErrorToast(true);
        console.error(
          `Download failed: Expected Blob for ${notificationTypeCode}`
        );
      }
      break;
    }

    case NotificationTypes.DOMAINDASHBOARDXPORT: {
      const id = extractReportId(filePath) || resourceId;

      try {
        const response = await getDomainDashboardReport(id);
        const blobData =
          response?.data instanceof Blob ? response.data : response;

        if (blobData instanceof Blob) {
          const filename = createPreciseTimestampedFilename(
            'DomainDashboardReport'
          );
          downloadBlob(blobData, `${filename}.xlsx`);
        } else {
          handleErrorToast(true);
          console.error(
            `Download failed: Expected Blob but got`,
            typeof blobData
          );
        }
      } catch (error) {
        handleErrorToast(true);
        console.error('API Error:', error);
      }
      break;
    }

    case NotificationTypes.TRANSCRIPTREPORT: {
      const id = extractReportId(filePath) || resourceId;

      try {
        const response = await getAIInvestigateTranscriptReport(id);
        const {blobData, fileName} = response;
        if (blobData instanceof Blob) {
          downloadBlob(blobData, `${fileName}`);
        } else {
          handleErrorToast(true);
          console.error(
            `Download failed: Expected Blob but got`,
            typeof blobData
          );
        }
      } catch (error) {
        handleErrorToast(true);
        console.error('API Error:', error);
      }
      break;
    }

    case NotificationTypes.BATCHPRINT: {
      const docResponse = await getPrintReport({
        notificationId,
        taskTypeCode: notificationTypeCode,
        filePath,
      });
      if (docResponse instanceof Blob) {
        const blob = docResponse;
        downloadBlob(blob, filename);
      } else {
        handleErrorToast(true);
        console.error(
          `Download failed for type ${notificationTypeCode}. Expected Blob response.`
        );
      }
      break;
    }
    case NotificationTypes.DOCUMENTPRINTER: {
      const docResponse = await getPrintReport({
        notificationId,
        taskTypeCode: notificationTypeCode,
        filePath,
      });
      if (docResponse instanceof Blob) {
        const blob = docResponse;
        downloadBlob(blob, filename, true);
      } else {
        handleErrorToast(true);
        console.error(
          `Download failed for type ${notificationTypeCode}. Expected Blob response.`
        );
      }
      break;
    }
    default:
      console.log(
        `No specific download handler for type: ${notificationTypeCode}`
      );
      break;
  }
};

function generateBaseName(
  notificationTypeCode: string,
  filePath: string
): string {
  let notificationBaseName = '';
  switch (notificationTypeCode) {
    case NotificationTypes.EXPORTREPORT: {
      const queryPart = filePath?.split('?')?.[1] ?? '';
      const key = queryPart.split('=')?.[0] ?? '';
      notificationBaseName =
        key === 'ProductionErrorReportID'
          ? 'ExportError'
          : notificationTypeCode;
      break;
    }
    default: {
      notificationBaseName = notificationTypeCode;
      break;
    }
  }
  return notificationBaseName;
}

export const checkIsItLink = (row: IBackgroundTask): boolean => {
  const {reportStatus, notificationTypeCode} = row;
  switch (notificationTypeCode) {
    case NotificationTypes.DOCUMENTPRINTER:
    case NotificationTypes.BATCHPRINT:
      return reportStatus === 'COMPLETED';
    case NotificationTypes.DOMAINDASHBOARDXPORT:
      return reportStatus === 'COMPLETED';
    case NotificationTypes.TRANSCRIPTREPORT:
      return reportStatus === 'COMPLETED';
    default:
      return row.message?.includes('?') ?? false;
  }
};

export const checkIsItViewable = (row: IBackgroundTask): boolean => {
  const {reportStatus, notificationTypeCode} = row;
  switch (notificationTypeCode) {
    case NotificationTypes.DOCUMENTPRINTER:
      return reportStatus === 'COMPLETED';
    default:
      return false;
  }
};

export function downloadBlob(
  blob: Blob,
  filename: string = 'downloaded_file',
  openInNewTab: boolean = false
): void {
  const url = URL.createObjectURL(blob);

  if (openInNewTab) {
    window.open(url, '_blank');
  } else {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  URL.revokeObjectURL(url);
}

export const extractBRID = (remarks: string): string | null => {
  const match = remarks.match(/[?&]BRID=(\d+)/i);
  return match ? match[1] : null;
};

export const extractReportId = (remarks: string): string | null => {
  const regex =
    /[?&](ReportID|IngestionID|IngestionErrorReportID|ProductionErrorReportID|DocViewReportID)=(\d+)/i;
  const match = remarks.match(regex);
  return match ? match[2] : null;
};

export const isAnalysis = (remarks: string | undefined): boolean => {
  if (!remarks) return false;
  return remarks.toLowerCase().includes('analysis'.toLowerCase());
};

export const getStepName = (status: string): string => {
  switch (status.toUpperCase()) {
    case 'FILEERROR':
    case 'CATALOGERROR':
      return 'Cataloguing';
    case 'COPYERROR':
    case 'INDEXDATAGENERROR':
      return 'Copying';
    case 'INDEXERROR':
      return 'Indexing';
    case 'APPROVEERROR':
      return 'Approval';
    default:
      return '';
  }
};

export const getUrlFromString = (
  remarks: string | undefined,
  ReportID: number,
  isbackgroudTask: boolean
): string => {
  if (!remarks) return '';

  const lowerRemarks = remarks.toLowerCase();
  let url: string | undefined;

  if (lowerRemarks.includes('communication')) {
    url = `DataAnalysisReport/CommunicationExplorerReport?ReportID=${ReportID}`;
  } else if (lowerRemarks.includes('concept')) {
    url = `DataAnalysisReport/conceptexplorer?ReportID=${ReportID}`;
  } else if (lowerRemarks.includes('term')) {
    url = `DataAnalysisReport/term/view?ReportID=${ReportID}`;
  } else if (lowerRemarks.includes('tally')) {
    url = `Report/tally?ReportID=${ReportID}`;
  } else if (lowerRemarks.includes('reviewer-count')) {
    url = `Review/ReviewerCountsReport?ReportID=${ReportID}`;
  } else {
    // If remarks doesn't match any keyword, return it as-is
    url = remarks;
  }

  // Prepend '../' only for background tasks
  if (isbackgroudTask) {
    url = `../${url}`;
  }

  return url;
};

const renderAccessibleHeader = (param: GridColumnHeaderParams) =>
  React.createElement(
    'span',
    {
      tabIndex: 0,
      role: 'columnheader',
      className: 'table_header',
      'data-testid': `table-header-${param?.colDef?.headerName ?? ''}`,
    },
    param.colDef.headerName
  );

const renderAccessibleCell = (params: any) =>
  React.createElement(
    'span',
    {
      tabIndex: 0,
      'aria-label': params?.value ?? '',
      role: 'gridcell',
      className: 'cell-label table_cells',
      'data-testid': `table-cell-${params?.value ?? ''}`,
    },
    params?.value ?? ''
  );

export const backgroundTasksUtils: GridColDef[] = [
  {
    field: 'documentName',
    headerName: 'ID/Name',
    width: 300,
    renderHeader: renderAccessibleHeader,
    renderCell: (params) => {
      return React.createElement(
        'span',
        {
          tabIndex: 0,
          'aria-label': params?.row ?? '',
          role: 'gridcell',
          className: 'cell-label table_cells',
          'data-testid': `table-cell-${params?.row?.documentName ?? ''}-name`,
        },
        React.createElement(DocumentNameCell, {
          params: params.row,
        })
      );
    },
  },
  {
    field: 'taskType',
    headerName: 'Task Type',
    flex: 1.3,
    renderHeader: renderAccessibleHeader,
    renderCell: renderAccessibleCell,
  },
  {
    field: 'securityGroup',
    headerName: 'Security Group',
    flex: 1.6,
    renderHeader: renderAccessibleHeader,
    renderCell: renderAccessibleCell,
  },
  {
    field: 'actualDocs',
    headerName: 'Actual Docs',
    flex: 1,
    renderHeader: renderAccessibleHeader,
    renderCell: renderAccessibleCell,
  },
  {
    field: 'errorDocCount',
    headerName: 'Error Docs',
    flex: 1,
    renderHeader: renderAccessibleHeader,
    renderCell: renderAccessibleCell,
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    flex: 1.5,
    renderHeader: renderAccessibleHeader,
    renderCell: renderAccessibleCell,
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    flex: 1.5,
    renderHeader: renderAccessibleHeader,
    renderCell: renderAccessibleCell,
  },
  {
    field: 'reportStatus',
    headerName: 'Status',
    flex: 1,
    renderHeader: renderAccessibleHeader,
    renderCell: renderAccessibleCell,
  },
  {
    field: 'message',
    headerName: 'Message',
    flex: 2,
    renderHeader: renderAccessibleHeader,
    renderCell: (params) => {
      const {
        isViewable = false,
        downloadFail,
        notificationTypeCode,
        reportStatus,
      } = params.row;

      switch (notificationTypeCode) {
        case 'BATCHPRINT':
          if (reportStatus === 'COMPLETED') {
            return React.createElement(DownloadFileButton, {
              onClick: () => handleDownload(params.row, downloadFail),
              isDownload: !isViewable,
              dataTestId:
                params?.row?.documentName ?? reportStatus ?? 'batch-print',
            });
          }
          return renderAccessibleCell({
            ...params,
            value: params?.row?.message ?? '',
          });
        case 'EXPORTREPORT':
        case 'GENAISUMMARYREPORT':
        case 'INGESTIONSUMMARY':
        case 'DATASETSUMMARYREPORT':
        case 'DOCUMENTPRINTER':
        case 'COLLSUMMARYREPORT':
          if (reportStatus === 'COMPLETED') {
            return React.createElement(DownloadFileButton, {
              onClick: () => handleDownload(params.row, downloadFail),
              isDownload: !isViewable,
              dataTestId:
                params?.row?.documentName ?? reportStatus ?? 'export-report',
            });
          }
          if (reportStatus === 'ERROR') {
            return React.createElement(
              'Typography',
              {
                title: 'Unable to Export, Please Contact Administrator',
                tabIndex: 0,
                'aria-label': params?.row ?? '',
                role: 'gridcell',
                className: 'cell-label table_cells',
                'data-testid': `table-cell-${params?.row?.documentName ?? ''}-message`,
              },
              'Unable to Export, Please Contact Administrator'
            );
          }
          if (reportStatus === 'INPROGRESS') {
            return React.createElement(
              'Typography',
              {
                title: '',
                tabIndex: 0,
                'aria-label': params?.row?.message ?? '',
                role: 'gridcell',
                className: 'cell-label table_cells',
                'data-testid': `table-cell-${params?.row?.documentName ?? ''}-message`,
              },
              ''
            );
          }
          break;
        case 'BACKGROUNDREPORT':
          return params?.row?.message?.toLowerCase().includes('communication')
            ? React.createElement(
                'span',
                {
                  title: params?.row?.message ?? '',
                  tabIndex: 0,
                  'aria-label': params?.row?.message ?? '',
                  role: 'gridcell',
                  className: 'cell-label table_cells',
                  'data-testid': `table-cell-${params?.row?.documentName ?? ''}-message`,
                },
                params?.row?.message ?? ''
              )
            : '';
        default:
          return React.createElement(
            'Typography',
            {
              title: params?.row?.message ?? '',
              tabIndex: 0,
              'aria-label': params?.row?.message ?? '',
              role: 'gridcell',
              className: 'cell-label table_cells',
              'data-testid': `table-cell-${params?.row?.documentName ?? ''}-message`,
            },
            params?.row?.message ?? ''
          );
      }
    },
  },
];
